// removed by extract-text-webpack-plugin
module.exports = {"featureArticleTag":"J42OCE0HZXgAOdP50jJLs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureArticleTag/FeatureArticleTag.module.scss
// module id = 756
// module chunks = 0